<template>
  <div>
    <slot
      name="content"
      :removeTag="removeTag"
      :removeSuburbTag="removeSuburbTag"
      :showResults="showResults"
      :submitSuggestedForm="submitSuggestedForm"
      :globalStore="globalStore"
      :email="email"
      :msg="msg"
      :phone="phone"
      :firstName="firstName"
      :closeSuccessModal="closeSuccessModal"
      :isCompareChecked="isCompareChecked"
      :showCareHomeForm="showCareHomeForm"
      :validateBeforeSubmit="validateBeforeSubmit"
    ></slot>
  </div>
</template>
<script setup>
import url from '../../helpers/url';
import axios from 'axios';
import {onMounted, reactive, ref} from 'vue'
import useGlobalStore from '../../store/globalStore'
import {useRestHomeCompare} from '../../composables/useRestHomeCompare'
import {useFormSubmit} from '../../composables/useFormSubmit'

const { showServerSideValidateErrors } = useFormSubmit()
const props = defineProps({
  regionId: {
    default: 0,
  },

  districtId: {
    default: 0,
  },

  checkedOptions: {
    type: Array,
    default: () => [],
  },
});

const suburbs = ref(props.checkedOptions);
const region = ref(props.regionId);
const district = ref(props.districtId);
const email = ref('');
const firstName = ref('');
const msg = ref('');
const phone = ref('');
const globalStore = useGlobalStore()
const confirmation = reactive({show: false, message: '', class: ''})
let isSubmitting = ref(false)

const { showCareHomeForm, isCompareChecked } = useRestHomeCompare()
const removeTag = (urlParameter) => {
  let urlValue = window.location.search;
  const value = url.getQueryStringParam(urlValue, urlParameter);
  urlValue = urlValue.replace(`${urlParameter}=${value}&`, '');
  location.href = urlValue;
};

const removeSuburbTag = (suburb) => {
  let urlValue = window.location.search;
  const value = url.getQueryStringParam(urlValue, 'suburbs');
  const suburbs = JSON.parse(decodeURIComponent(value));
  const index = suburbs.indexOf(suburb);

  if (index > -1) {
    suburbs.splice(index, 1);
  }

  if (suburb.length > 0) {
    urlValue = urlValue.replace(`suburbs=${value}&`, `suburbs=${JSON.stringify(suburbs)}&`);
    location.href = urlValue;
  } else {
    urlValue = urlValue.replace(`suburbs=${value}&`, '');
    location.href = urlValue;
  }
};

const submitSuggestedForm = () => {
  globalStore.setModal({ name: 'careHomeSuggestedForm'})
};

const validateBeforeSubmit = (e) => {
  isSubmitting.value = true
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  let formData = new FormData(e.target);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    formData.set('g-recaptcha-response', token);
    axios.post(e.target.action, formData).then(function (response) {
      window.dataLayer = window.dataLayer || [];
      const data = JSON.parse(response.data.dataLayerData);

      data.forEach((item) => {
        window.dataLayer.push({
          'event': 'enquiry',
          'enquiry_type': 'Add to compare',
          'items': {
            item_id: item.villageId,
            item_name: item.villageName,
            currency: 'NZD',
            index: '1',
            item_brand: item.villageOperator,
            item_category: item.villageType,
            item_category2: '',
            item_category3: item.subscription,
            item_category4: item.region,
            item_category5: item.district,
            item_variant: item.villageOperatorId,
            quantity: 1
          },
        });
      });

      globalStore.setModal({ name: 'careHomeSuggestedFormSuccess'})
    }).catch(error => {
      showServerSideValidateErrors(error, isSubmitting, confirmation)
    });
  });
}

const closeSuccessModal = () => {
  window.location = '/rest-homes/recommended-reading-watching';
};

const showResults = () => {
  let urlValue = window.location.search;

  const nameValue =  url.getQueryStringParam(urlValue, 'name');

  // Replace region with new value
  const regionValue = url.getQueryStringParam(urlValue, 'region');

  if (region.value) {
    if (regionValue) {
      urlValue = urlValue.replace(`region=${regionValue}&`, `region=${region.value}&`);
    } else {
      urlValue = urlValue.replace(`name=${nameValue}&`, `region=${region.value}&name=${nameValue}&`);
    }
  } else {
    urlValue = urlValue.replace(`region=${regionValue}&`, '');
  }

  // Replace district with new value
  const districtValue = url.getQueryStringParam(urlValue, 'district');
  if (district.value) {
    if (districtValue) {
      urlValue = urlValue.replace(`district=${districtValue}&`, `district=${district.value}&`);
    } else {
      urlValue = urlValue.replace(`name=${nameValue}&`, `district=${district.value}&name=${nameValue}&`);
    }
  } else {
    urlValue = urlValue.replace(`district=${districtValue}&`, '');
  }

  // Replace suburbs with new value
  const suburbValue = url.getQueryStringParam(urlValue, 'suburbs');
  if (suburbs.value.length > 0) {
    if (suburbValue) {
      urlValue = urlValue.replace(`suburbs=${suburbValue}&`, `suburbs=${JSON.stringify(suburbs.value)}&`);
    } else {
      urlValue = urlValue.replace(`name=${nameValue}&`, `suburbs=${JSON.stringify(suburbs.value)}&name=${nameValue}&`);
    }
  } else {
    urlValue = urlValue.replace(`suburbs=${suburbValue}&`, '');
  }

  location.href = urlValue;
};

onMounted(() => {
  email.value = localStorage.getItem('suggestedEmail');
  firstName.value = localStorage.getItem('suggestedName');
  msg.value = localStorage.getItem('suggestedMsg');
  phone.value = localStorage.getItem('suggestedPhone');
});

</script>
